// extracted by mini-css-extract-plugin
export default {"root":"cyw3E","wrapper":"nHrhJ","input":"hJUeb","checked":"aBpUL","checkIcon":"mTOoD","labelText":"iDK0l","labelDefaultSize":"HGy1Y","labelLargeSize":"PRIdK","disabled":"qOFsE"};